import React from "react";
import {Text, Image, Box} from "@chakra-ui/react";

function Mydevice() {
    return (
        <>
            <Box boxSize='sm'>
                <Image src={process.env.PUBLIC_URL +'/banner/comingsoon.png'} alt='Coming Soon' />
            </Box>
        </>
    );
}

export default Mydevice;